import {gql} from "apollo-boost";

export const ADD_UPLOAD_YEALINK_IMPORT_DATA = gql`
  mutation addUploadYeaLinkImportData(
    $typeId: ID!,
    $importType: YeaLinkImportType!,
    $deleteOldRecord: Boolean,
    $yeaLinkImportDataArray: [YeaLinkImportDataInput]
  ) {
    addUploadYeaLinkImportData(
      typeId: $typeId
      importType: $importType
      deleteOldRecord: $deleteOldRecord
      yeaLinkImportDataArray: $yeaLinkImportDataArray
    ) {
      successCount
      failCount
      resultAddUploadYeaLinkImportData{
        meetingTheme
        meetingNo
        meetingType
        mode
        startTime
        endTime
        meetingDuration
        meetingDurationInt
        meetingRoom
        maximumNumberOfConcurrentParties
        numberOfParticipants
        participantName
        rolePermissions
        accountType
        grouping
        meetingTime
        departureTime
        stayDuration
        stayDurationInt
        ipAddress
        callingType
        deviceModel
        status
        remark
      }
    }
  }
`;

export const ADD_UPLOAD_YEALINK_LEARN_TIME = gql`
  mutation addUploadYeaLinkLearnTime(
    $classSectionId: ID!,
    $vdoSetUnitId: ID!,
    $vdoSetTopicId: ID!,
    $deleteOldRecord: Boolean,
    $yeaLinkImportDataArray: [YeaLinkImportDataInput]
  ) {
    addUploadYeaLinkLearnTime(
      classSectionId: $classSectionId
      vdoSetUnitId: $vdoSetUnitId
      vdoSetTopicId: $vdoSetTopicId
      deleteOldRecord: $deleteOldRecord
      yeaLinkImportDataArray: $yeaLinkImportDataArray
    ) {
      successCount
      failCount
      resultAddUploadYeaLinkImportData{
        meetingTheme
        meetingNo
        meetingType
        mode
        startTime
        endTime
        meetingDuration
        meetingDurationInt
        meetingRoom
        maximumNumberOfConcurrentParties
        numberOfParticipants
        participantName
        rolePermissions
        accountType
        grouping
        meetingTime
        departureTime
        stayDuration
        stayDurationInt
        ipAddress
        callingType
        deviceModel
        status
        remark
      }
    }
  }
`;
